import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SnackBarUI from '../../comman/SnackBarUI'
import { deleteSubCategoryAction } from '../../redux/toolkit/sub-category/deleteSubCategory'
import { getSubCategoryAction } from '../../redux/toolkit/sub-category/getSubCategory'
import PropTypes from 'prop-types';

export default function DeleteSubCategory({ sub_cat_id, state, setState }) {
    // state
    const dispatch = useDispatch()
    const delSubCat = useSelector(state => state.deleteSubCategory)
    const { status, message } = delSubCat

    const [snack, setSnack] = useState(false)

    // fn
    const handleClose = () => {
        setState(false)
    }

    const delCatHandle = async () => {
        const deleteSubCat = await dispatch(deleteSubCategoryAction({ sub_category_id: sub_cat_id }))
        if (deleteSubCat?.payload?.status == 200) {
            await dispatch(getSubCategoryAction({ is_deleted: false }))
        }
        setSnack(true)
        setState(false)
    }

    return (
        <>
            <Dialog open={state} onClose={handleClose}>
                <DialogTitle>Deleting request !</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete the selected item ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={delCatHandle} autoFocus> Agree</Button>
                    <Button onClick={handleClose}>Disagree</Button>
                </DialogActions>
            </Dialog>


            <SnackBarUI state={snack} setState={setSnack} status={status} message={message} />
        </>

    )
}

DeleteSubCategory.propTypes = {
    sub_cat_id: PropTypes.string,
    state: PropTypes.any,
    setState: PropTypes.any
};